import { store } from '@/apis';

export default {
  namespaced: true,
  state: {
    // 切换表格
    templateType: 'manage',
    templateList: [{
      key: 'manage', value: '门店管理',
    }, {
      key: 'group', value: '门店分组',
    }],
    // 门店所有列表（前端自助分页+筛选）
    storeAll: [],
    provinceAll: [],
    formatAll: [],
    // 门店管理列表（分页）
    storeList: {
      list: [],
      total: 0,
    },
    // 门店分组列表
    storeGroup: {
      list: [],
      total: 0,
    },
    // 门店分组管理-选中分组交互数据
    storeGroupName: '',
    storeIdList: [],
  },
  mutations: {
    updateStoreManage(state, data = {
      list: [],
      total: 0,
    }) {
      Object.assign(state.storeList, data);
    },
    updateStoreGroup(state, data = {
      list: [],
      total: 0,
    }) {
      Object.assign(state.storeGroup, data);
    },
    updateTemplatetype(state, data) {
      state.templateType = data;
    },
    updateStoreAll(state, data) {
      state.storeAll = data;
    },
    updateProvinceAll(state, data) {
      state.provinceAll = data;
    },
    updateFormatAll(state, data) {
      state.formatAll = data;
    },
    updateModalStoreIdList(state, data = []) {
      state.storeIdList = [].concat(data);
    },
    updateModalGroupName(state, data = '') {
      state.storeGroupName = data;
    },
  },
  actions: {
    // 门店管理列表
    async fetchManage({
      commit,
    }, payload) {
      commit('updateStoreManage');
      const { list, total } = await store.getStoreManage(payload);
      commit('updateStoreManage', { list, total });
    },
    // 门店分组列表
    async fetchGroup({
      commit,
    }, payload) {
      commit('updateStoreGroup');
      const { list, total } = await store.getStoreGroup(payload);
      commit('updateStoreGroup', { list, total });
    },
    // 删除group
    async fetchGroupDelete(context, payload) {
      await store.deleteStoreGroup(payload);
    },
    // 新增group
    async fetchGroupAdd(context, payload) {
      await store.addStoreGroup(payload);
    },
    // 更新group
    async fetchGroupEdit(context, payload) {
      await store.editStoreGroup(payload);
    },
    // 门店汇总列表
    async fetchStoreAll({ commit }, payload) {
      const rst = await store.getStoreAllForChose(payload);
      commit('updateStoreAll', rst);
    },
    async fetchProvinceAll({ commit }) {
      const rst = await store.getSelectListProvince();
      commit('updateProvinceAll', rst);
    },
    async fetchFormatAll({ commit }) {
      const rst = await store.getSelectListFormat();
      commit('updateFormatAll', rst);
    },
  },
};
